/* eslint-disable @typescript-eslint/no-empty-object-type, @typescript-eslint/no-unnecessary-type-constraint */

import { GridRenderCellParams, GridValidRowModel } from '@mui/x-data-grid-pro';
import { FunctionComponent } from 'react';
import { Union } from 'ts-toolbelt';

import { RenderCellType } from '~/components/DataGridCustom/DataGridCustom.types';

interface RenderCellComponentProps<R extends GridValidRowModel = any, V = any> {
  value: Union.Nullable<V>;
  row: R;
}

type PropsGetter<R extends GridValidRowModel, V, P> = (params: GridRenderCellParams<R, V>) => P;

export const cellFactory = <P extends {}, R extends GridValidRowModel = any, V = any>(
  Component: FunctionComponent<P & RenderCellComponentProps>,
  propsOrGetter?: P | PropsGetter<R, V, P>,
): RenderCellType<R, V> => {
  return (params) => {
    const props = {
      row: params.row,
      value: params.value,
    };
    const additionalProps = typeof propsOrGetter === 'function' ? (propsOrGetter as any)(params) : propsOrGetter;
    return <Component {...props} {...additionalProps} />;
  };
};
